var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRsaReadyToPublish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 -3.05176e-05C4.48024 -3.05176e-05 0.000244141 4.47997 0.000244141 9.99997C0.000244141 15.52 4.48024 20 10.0002 20C15.5202 20 20.0002 15.52 20.0002 9.99997C20.0002 4.47997 15.5202 -3.05176e-05 10.0002 -3.05176e-05ZM7.29025 14.29L3.70024 10.7C3.31024 10.31 3.31024 9.67997 3.70024 9.28997C4.09024 8.89997 4.72024 8.89997 5.11024 9.28997L8.00025 12.17L14.8802 5.28997C15.2702 4.89997 15.9002 4.89997 16.2902 5.28997C16.6802 5.67997 16.6802 6.30997 16.2902 6.69997L8.70024 14.29C8.32024 14.68 7.68024 14.68 7.29025 14.29Z",
    fill: "#1098F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRsaReadyToPublish);
export default __webpack_public_path__ + "static/media/RsaReadyToPublish.4f8d40537c2cc88df4caf22ae5c7465f.svg";
export { ForwardRef as ReactComponent };